import { HoverCard, HoverCardType, IHoverCardProps } from '@fluentui/react/lib/HoverCard';

export interface IPHoverCardProps extends IHoverCardProps {}
export { HoverCardType as IPHoverCardType };

export const IPHoverCard = (props: IPHoverCardProps) => {
  return <HoverCard {...props} />;
};
